import { ADD_MARK } from '../../../../../../../../constants/selectionOpts';

export default (operationsArray) => {
  const isComment = operationsArray.some((operation) => {
    const { type } = operation;
    if (type === ADD_MARK) {
      const {
        mark: { type: markType },
      } = operation;
      if (markType === 'comment') return true;
    }

    return false;
  });

  return isComment;
};
